import { isNil } from 'lodash'

/**
 * Takes a number and inserts commas for friendly display.
 * Because a number is assumed, returns 0 if x is null or undefined.
 * @param {number} x 
 */
export function formatWithCommas (x) {
  if (isNil(x)) {
    return '0'
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}



// WEBPACK FOOTER //
// ./src/components/foundation/number.js